import SwishError from './SwishError';

export default class UnauthorizedError extends SwishError {
  isUnauthorizedError() { return true; }
}
